import React from 'react';
import { Link } from 'react-router-dom';

import { Text } from '../atom/Text';
import { Flex } from '../atom/Layout';
import { Padding } from '../atom/Padding';
import { HorizonGreyLine } from '../atom/HorizonGreyLine';
import { Image } from '../atom/Image';
import { HorizonLine } from '../molecules/HorizonLine';
import { StickeyTabBar } from '../organism/StickyTabBar';
import Coupon from '../organism/Coupon';
import { ThumbnailView } from '../organism/ThumbnailView';
import { ArrowToggle, QnAToggle } from '../organism/Toggle';

import TEXT from '../../../lib/text/textSalesBabyface.json';
export const PDPTemplate = ({
  children,
  productInfo = {
    title: '',
    instruction: '',
    activeCampaigns: [],
    eventPrice: 0,
    price: 0,
    shippingFee: 0,
  },
  thumbnailImageList = [{ src: '', alt: '' }],
  couponInfo = {
    title: '',
    discount: '',
    code: '',
    startDate: '',
    endDate: '',
  },
  deliveryInfo,
  bannerList = [{ src: '', alt: '', path: '' }],
  tabContent = {
    deliveryTab: [{ id: '', title: '', description: [''] }],
    qnaTab: [{ question: '', answer: '' }],
  },
  tabList = [STORY, REVIEW, DELIVERY, QUESTION],
}) => (
  <>
    <ThumbnailView imageList={thumbnailImageList} />
    <Flex column alignItems="flex-start" padding="0.625rem 1.25rem 1.25rem">
      <Text weight="bold">{productInfo.title}</Text>
      <Text
        size={12}
        color="caption"
        style={{ marginTop: '0.3125rem', lineHeight: 1.5 }}
      >
        {productInfo.instruction}
      </Text>
    </Flex>
    <HorizonGreyLine />
    {deliveryInfo}
    <StickeyTabBar
      tabList={STICKY_MENU.filter((menu) => tabList.includes(menu.path))}
    />
    {children}
    {tabList.includes(DELIVERY) && (
      <div id={DELIVERY}>
        <HorizonLine text={labelDelivery} />
        <ArrowToggle content={tabContent.deliveryTab} />
      </div>
    )}
    {tabList.includes(QUESTION) && (
      <div id={QUESTION}>
        <HorizonLine text={labelQuestion} style={{ marginTop: '1.25rem' }} />
        <QnAToggle content={tabContent.qnaTab} />
      </div>
    )}
    {bannerList.map((item) => (
      <Link to={item.path} key={item.alt}>
        <Image
          src={item.src}
          alt={item.alt}
          margin="0.625rem 0 0"
          cursor="pointer"
        />
      </Link>
    ))}
  </>
);

const {
  textMonetaryUnit,
  textShippingFee,
  labelReview,
  labelStory,
  labelDelivery,
  labelQuestion,
} = TEXT;

export const REVIEW = 'review';
export const STORY = 'story';
export const DELIVERY = 'delivery';
export const REFUND = 'refund';
export const QUESTION = 'question';

const STICKY_MENU = [
  [STORY, labelStory],
  [REVIEW, labelReview],
  [DELIVERY, labelDelivery],
  [QUESTION, labelQuestion],
].map((menu) => ({ path: menu[0], label: menu[1] }));
